/**
 * The two standard welcomes (Tom 2026-10-12, job #83): the same two clips for
 * every English-known course, replacing the per-course welcome clips.
 *
 *   FIRST-EVER   /welcome/first.mp3        Aran, once per device, the very first
 *                                          course link (streamed by welcome-shell.js).
 *   NEW COURSE   /welcome/new/<code>.mp3   "Welcome to <language>, let's get
 *                                          started right away!", once per course
 *                                          per device, for a learner choosing
 *                                          another course.
 *
 * Both are static files built by tools/welcome/standard (real Aran takes
 * spliced, clone only for words no real take has). Aran's voice is English
 * only, so other known languages keep their existing welcome.
 */
/**
 * Master switch (Tom 2026-10-12 19:39Z: "We don't need the welcome clips yet").
 * Off: no first-ever or new-course welcome clip plays (the shell has the same
 * switch in public/welcome-shell.js). The files stay; set true to restore.
 */
export const WELCOME_CLIPS_ON = false

export const STANDARD_FIRST_WELCOME_URL = '/welcome/first.mp3'

const KEY = 'ssi-new-course-welcome:'

/** The new-course welcome for an English-known course, or null. */
export function newCourseWelcomeUrl(courseCode: string | undefined | null): string | null {
  if (!courseCode || !/^[a-z0-9_]+_for_eng$/.test(courseCode)) return null
  return `/welcome/new/${courseCode}.mp3`
}

export function newCourseWelcomeHeard(courseCode: string): boolean {
  try { return localStorage.getItem(KEY + courseCode) === 'true' } catch { return true }
}

export function markNewCourseWelcomeHeard(courseCode: string): void {
  try { localStorage.setItem(KEY + courseCode, 'true') } catch { /* best effort */ }
}

/**
 * True when this learner is choosing a course they have not started: an
 * English-known course, never welcomed on this device, with no progress in it.
 * The first-ever course is marked heard by the shell when its tap plays, so a
 * brand-new learner never hears both welcomes back to back.
 */
export function newCourseWelcomeDue(opts: { courseCode?: string | null; knownLang?: string | null; hasProgress: boolean }): boolean {
  if (!WELCOME_CLIPS_ON) return false
  if (opts.knownLang !== 'eng' || opts.hasProgress) return false
  const code = opts.courseCode || ''
  return !!newCourseWelcomeUrl(code) && !newCourseWelcomeHeard(code)
}
